const tryRequire = require('try-require')

module.exports = function (state, opts, config) {
    const HtmlWebpackIncludeAssetsPlugin = tryRequire('html-webpack-include-assets-plugin')

    if (!HtmlWebpackIncludeAssetsPlugin) {
        return {} // waiting for an installation
    }
    
    // const FURTHER_REF = paths.FURTHER_REF
    const FILES_TO_APPEND = state.FILES_TO_APPEND
    if (FILES_TO_APPEND.length) {
        FILES_TO_APPEND.forEach(file => {
          if (typeof file === 'string' || file.assets && file.assets.length) {
            config.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
              assets: file,
              append: false
            }))
          }
        })
      }
    
    if (opts.client) {
        if (opts.client.prependFiles) {
            opts.client.prependFiles.forEach(file => {
                config.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
                    assets: file,
                    append: false,
                    silent: true,
                    publicPath: false
                }))
            })
        }
        if (opts.client.appendFiles) {
            opts.client.appendFiles.forEach(file => {
                config.plugins.push(new HtmlWebpackIncludeAssetsPlugin({
                    assets: file,
                    append: true,
                    publicPath: false
                }))
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/technologies/include-assets.js